import { render, staticRenderFns } from "./compra-pedido.vue?vue&type=template&id=3ab9fb66"
import script from "./compra-pedido.vue?vue&type=script&lang=js"
export * from "./compra-pedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Purchase: require('/home/luiz/Sistemas/loja/components/Purchase.vue').default})
